var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tabs",
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-tabs-nav",
          attrs: {
            role: "tablist",
          },
        },
        _vm._l(_vm.tabs, function (tab, index) {
          return _c(
            "button",
            {
              key: index,
              ref: tab.selectorId,
              refInFor: true,
              class: [
                tab.isActive ? "is-active" : "",
                tab.icon !== "" && tab.name !== ""
                  ? "cw-tabs-nav-icon-text-" + tab.icon
                  : "",
                tab.icon !== "" && tab.name === ""
                  ? "cw-tabs-nav-icon-solo-" + tab.icon
                  : "",
              ],
              attrs: {
                "aria-selected": tab.isActive,
                "aria-controls": tab.id,
                id: tab.selectorId,
                tabindex: tab.isActive ? 0 : -1,
              },
              on: {
                click: function click($event) {
                  return _vm.selectTab(tab.selectorId)
                },
                keydown: function keydown($event) {
                  return _vm.handleKeyEvent($event)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(tab.name) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-tabs-content",
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }